import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import MyLink from "components/MyLink"
import { BfSlash, BfCategoryIcon } from "./BfIcons"
import BfCountdown from "./BfCountdown"
import "./blackFriday2026.scss"
import { BF_END, getBfListUrl, getBfSubcategories } from "config/blackFriday2026"

/** Texts of the two 2026 popups, as approved by the client (2 Nov). */
const COPY = {
  start: {
    kicker: "6-13 noiembrie",
    title: "Nu rata reducerile!",
    text: [
      "Până la 97% reducere la peste 830 de produse.",
      "Grăbește-te! Stocurile sunt limitate, iar produsele se pot epuiza rapid.",
      "Profită de oferte cât timp sunt disponibile!"
    ],
    cta: "Descoperă ofertele"
  },
  last: {
    kicker: "Ultima șansă",
    title: "Se încheie azi, la ora 20:00",
    text: ["Finalizează comanda pentru ofertele Black Friday din coș."],
    cta: "Vezi produsele"
  }
}

const isDismissed = (storageKey) => {
  try {
    return sessionStorage.getItem(storageKey) === "true"
  } catch (e) {
    return false
  }
}

/**
 * Black Friday 2026 popup, bottom-right. Once per browser session: closing
 * it (× or a link) is remembered in sessionStorage under `storageKey`.
 * `variant`: "start" (whole campaign until the last morning) or "last"
 * (last day, with a countdown to 20:00).
 */
const BfPopup = ({ variant, storageKey }) => {
  const [isVisible, setIsVisible] = useState(() => !isDismissed(storageKey))
  const productCategories = useSelector((state) => state?.backData?.productCategory)

  useEffect(() => {
    if (isDismissed(storageKey)) setIsVisible(false)
  }, [storageKey])

  if (!isVisible) return null

  const copy = COPY[variant] || COPY.start
  const close = () => {
    setIsVisible(false)
    try {
      sessionStorage.setItem(storageKey, "true")
    } catch (e) {}
  }

  return (
    <div className={`bf-popup bf-popup--${variant}`} data-test-id={`bfPopup-${variant}`}>
      <BfSlash className="bf-popup__slash" color={variant === "last" ? "rgba(0,0,0,0.18)" : "#ea0029"} />
      <button type="button" className="bf-popup__close" onClick={close} title="Închide" aria-label="Închide">
        ×
      </button>
      <div className="bf-popup__kicker">{copy.kicker}</div>
      <div className="bf-popup__brand">
        Black <b>Friday</b>
      </div>
      <div className="bf-popup__title">{copy.title}</div>
      <div className="bf-popup__text">
        {copy.text.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>

      {variant === "start" && (
        <div className="bf-popup__cats">
          {getBfSubcategories(productCategories).map((c) => (
            <MyLink key={c.treeCode} to={getBfListUrl(c.treeCode)} onClick={close} className="bf-popup__cat" title={c.title}>
              <BfCategoryIcon icon={c.icon} size={38} />
            </MyLink>
          ))}
        </div>
      )}
      {variant === "last" && (
        <BfCountdown target={BF_END} label="mai sunt" compact className="bf-popup__countdown" />
      )}

      <MyLink
        to={getBfListUrl()}
        onClick={close}
        className={`bf-btn ${variant === "last" ? "bf-btn--light" : "bf-btn--primary"} bf-popup__cta`}
      >
        {copy.cta}
      </MyLink>
    </div>
  )
}

export default BfPopup
